import { render } from "./Welcome.vue?vue&type=template&id=730e4c42&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=730e4c42&scoped=true&lang=css"

import exportComponent from "C:\\0_PROJECTS\\EcoSim\\Csongrad\\sar_es_tuz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-730e4c42"]])

export default __exports__